import { render } from "./MaterialPaginationItem.vue?vue&type=template&id=d8baed3c"
import script from "./MaterialPaginationItem.vue?vue&type=script&lang=js"
export * from "./MaterialPaginationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__